import React, { useEffect, useState, useRef } from 'react'
import { StyleSheet, Text, Image, View, Alert, StatusBar, Linking, TouchableOpacity, Dimensions } from 'react-native'
import { CameraView as ExpoCameraView, CameraType, useCameraPermissions } from 'expo-camera'
import theme from '../../../theme'
import * as MediaLibrary from 'expo-media-library'
import styles from './CameraViewStyles'
import { tr } from 'date-fns/locale'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { Loader } from './Components/Loader'
import Svg, { Rect, Mask, Defs } from 'react-native-svg'

export default function CameraView({ closeBottomSheet, returnedValue, title, description, barcode, closeCameraModal }) {
    const { languageFile } = getLanguage()
    const [hasCameraPermission, setHasCameraPermission] = useState(null)
    const [permission, requestPermission] = useCameraPermissions()
    const [image, setImage] = useState(null)
    const [type, setType] = useState('back')
    const [flash, setFlash] = useState('off')
    const [scanInProgress, setScanInProgress] = useState(false)
    const cameraRef = useRef(null)
    const [loading, setLoading] = useState(true)
    const { width, height } = Dimensions.get('window')

    useEffect(() => {
        getPermission()
    }, [])

    useEffect(() => {
        setHasCameraPermission(permission?.status === 'granted')
        if (permission != null || permission != undefined) {
            setLoading(false)
        }
    }, [permission])

    const getPermission = async () => {
        await requestPermission()
        if (permission.status != 'granted' && permission.canAskAgain === false) {
            Linking.openSettings()
        }
        if (permission.status === 'granted' && permission.canAskAgain) {
            await requestPermission()
        }
    }

    const scan = async (scanningResult) => {
        try {
            if (scanInProgress) {
                return
            }

            setScanInProgress(true)
            returnedValue(scanningResult.data)
        } catch (error) {
            console.error(error)
        } finally {
            setScanInProgress(false)
        }
    }

    if (loading) {
        return <Loader />
    }

    if (!loading && hasCameraPermission === false) {
        return (
            <View style={styles.container}>
                <Image style={styles.imageAsset} source={require('../../../assets/noCameraPermissions.png')} />
                <Text style={[styles.titleText]}>{languageFile.not_have_camera_permissions}</Text>
                <Text style={[styles.descriptionText]}>{languageFile.activate_from_settings}</Text>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity style={styles.mainButton} onPress={() => getPermission()}>
                        <Text style={styles.mainButtonText}>{languageFile.modify_permissions}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        )
    }

    return (
        <View style={styles.container}>
            {barcode ? (
                <View style={styles.containerCamera}>
                    <ExpoCameraView 
                        onBarcodeScanned={(scanningResult) => scan(scanningResult)} 
                        style={styles.camera}
                        barcodeScannerSettings={{
                            barcodeTypes: ["qr", "pdf417"],
                        }}
                    />
                </View>
            ) : (
                <ExpoCameraView
                    style={styles.camera}
                    ref={cameraRef}
                    facing={type}
                    flash={flash}
                    barcodeScannerSettings={{
                        barcodeTypes: ["code128", "qr", "pdf417"],
                    }}
                    onBarcodeScanned={(scanningResult) => scan(scanningResult)}
                />
            )}

            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    width: width,
                    height: height,
                }}
            >
                <Svg height={height} width={width}>
                    <Defs>
                        <Mask id='mask' x='0' y='0' width='100%' height='100%'>
                            <Rect height='100%' width='100%' fill='white' />
                            <Rect x={width * 0.1} y={height / 2 - width * 0.4} width={width * 0.8} height={width * 0.8} fill='black'></Rect>
                        </Mask>
                    </Defs>
                    <Rect height='100%' width='100%' fill='rgba(0, 0, 0, 0.4)' mask='url(#mask)' />
                </Svg>
                <Image style={styles.image} source={require('../../../assets/marcoQRScan.png')} />
            </View>

            {/* <StatusBar backgroundColor={'black'} barStyle='dark-content' /> */}

            {closeCameraModal && (
                <TouchableOpacity
                    style={{ width: 50, position: 'absolute', bottom: 30 }}
                    onPress={() => {
                        closeCameraModal()
                    }}
                >
                    <Image style={styles.imageAsset} source={require('../../../assets/exitButton.png')} />
                </TouchableOpacity>
            )}
        </View>
    )
}
